<template>
    <div class="c-table location-mapping-result-table">
        <template v-if="!isLoading">
            <div class="c-thead">
                <div v-text="'Sklep EuroPlatform'" class="c-td is-1" />
                <div v-text="'Sklep Kaucyjni.pl'" class="c-td is-2" />
                <div v-text="'Stan'" class="c-td is-3" />
            </div>

            <div class="c-tbody">
                <div
                    v-for="row in rows"
                    :key="row.epLoc.id"
                    class="c-row"
                >
                    <div class="c-tr">
                        <location-badge
                            class="c-td is-1"
                            :logo="$options.LOGOS.EP"
                            :location="row.epLoc"
                        />

                        <location-badge
                            v-if="row.kplLoc"
                            class="c-td is-2"
                            :logo="$options.LOGOS.KPL"
                            :location="row.kplLoc"
                        />

                        <div v-else v-text="'---'" class="c-td is-2" />

                        <div class="c-td is-3">
                            <span
                                v-if="row.statusMeta"
                                v-tooltip="row.statusMeta.tooltip"
                                class="status w-100"
                                :class="row.statusMeta.class"
                            >
                                <span v-text="row.statusMeta.text" />
                                <a-icon v-if="row.statusMeta.tooltip" icon="Info" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <div v-else class="text-center">
            <page-preloader
                min-height="5rem"
                loading-status="loading"
            />
        </div>
    </div>
</template>

<script>
import locationMappingMixin, { MAPPING_STATUS } from '@/components/drs/service/location-mapping.mixin'
import { LOGOS } from '@/utils/constants/drs/logos'

const STATUS_CONFIG = {
    [MAPPING_STATUS.NEW]: {
        class: 'is-info',
        text: 'Nowy',
        tooltip: 'Utworzyliśmy nowy sklep w Kaucyjni.pl na podstawie danych sklepu w EuroPlatform'
    },

    [MAPPING_STATUS.MAPPED]: {
        class: 'is-success',
        text: 'Powiązany',
        tooltip: 'Powiązaliśmy wybrane przez Ciebie sklepy'
    },

    [MAPPING_STATUS.ERROR]: {
        class: 'is-danger',
        text: 'Błąd',
        tooltip: 'Aktywacja usługi w EuroPlatform jest niemożliwa,<br/>ponieważ odpowiadający mu sklep w Kaucyjni.pl ma aktywną taryfę roczną'
    }
}

export default {
    mixins: [locationMappingMixin],

    LOGOS,

    data: () => ({
        isLoading: false
    }),

    async created() {
        try{
            this.isLoading = true
            await this.$store.dispatch('drs/fetchLocationsWithCompanyId')
        } finally {
            this.isLoading = false
        }
    },

    computed: {
        locationsEP() {
            return this.$store.getters.locationsToActivate
        },

        locationsKPL() {
            return this.$store.getters['drs/getLocations']
        },

        mappingResults() {
            return this.$store.getters.drsLocationMappingResults
        },

        rows() {
            const replicatedLocations = this.$store.getters.replicatedLocationsByEpId

            return this.locationsEP.map(epLoc => {
                const result = this.mappingResults[epLoc.id]
                const status = result?.status || MAPPING_STATUS.ERROR

                // Store location fetched after activation
                const activatedKplLoc = this.locationsKPL.find(
                    loc => loc.ep_location_id === epLoc.id
                )

                // Originally selected location from mapping step
                const selectedKplLocId = this.$store.getters.drsLocationMappings[epLoc.id]
                const selectedKplLoc = this.$store.getters.unMappedDrsLocations.find(
                    loc => loc.id === selectedKplLocId
                )
                const replicatedKplLoc = replicatedLocations[epLoc.id]

                // For failed mapping show originally selected location
                const kplLoc = status === MAPPING_STATUS.ERROR
                    ? selectedKplLoc
                    : (activatedKplLoc || selectedKplLoc || replicatedKplLoc)

                return {
                    epLoc,
                    kplLoc: kplLoc
                        ? {
                            ...kplLoc,
                            name: kplLoc.full_name || kplLoc.name
                        }
                        : null,
                    status,
                    statusMeta: status === MAPPING_STATUS.REPLICATED
                        ? null
                        : (STATUS_CONFIG[status] || STATUS_CONFIG[MAPPING_STATUS.ERROR])
                }
            })
        }
    },

    beforeDestroy() {
        this.clearLocationMappingFlow()
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';
@import './location-mapping-table';

.location-mapping-result-table {
    @extend .location-mapping-table-base;

    .c-td {
        --width: 40%;
    }

    .is-3 {
        --width: 8rem;
        max-width: var(--width);
        display: flex;
        justify-content: center;
    }
}
</style>